
import { computed, defineComponent, PropType, Ref } from 'vue';
import { HeroBannerTileModel, HeroBannerSimpleTileModel, HeroBannerBlocksTileModel } from '@/types/B2BcontentServerContract';
import HeroBannerTile from '@/shared/content/blocks/HeroBannerTile.vue';
import HeroBannerSimpleTile from '@/shared/content/blocks/HeroBannerSimpleTile.vue';
import HeroBannerBlocksTile from '@/shared/content/blocks/HeroBannerBlocksTile.vue';
import HeroBannerSimpleBlocksTile from '@/shared/content/blocks/HeroBannerSimpleBlocksTile.vue';

export default defineComponent({
    name: 'HeroBannerHandler',
    components: { HeroBannerTile, HeroBannerSimpleTile, HeroBannerBlocksTile, HeroBannerSimpleBlocksTile },
    props: {
        content: {
            type: Object as PropType<HeroBannerTileModel | HeroBannerSimpleTileModel | HeroBannerBlocksTileModel>,
            required: true,
        },
    },
    setup(props) {
        const bannerComponent: Ref<string> = computed(() => {
            return props.content?.type ?? 'HeroBannerTile';
        });

        return {
            bannerComponent,
        };
    },
});
